(function($) {
    // Get Window Width and Height
    var windowWidth = $(window).outerWidth();
    var windowHeight = $(window).height();

    /* Document ready functions */
    jQuery(document).ready(function($) {
        // Current packages
        var firstSlide1 = $('.current-packages-puffs .big .front');
        var puffSlide1 = new Swiper('.current-packages-puffs .content', {
            grabCursor: true,
            slidesPerView: 'auto',
            preloadImages: false,
            lazy: true,
            keyboard: {
                enabled: true
            },
            on: {
                init: function (touchStart) {
                    $(firstSlide1).removeClass('active');
                },
                init: function (reachBeginning) {
                    $(firstSlide1).removeClass('active');
                }
            }
        });

        /*var firstSlide1 = $('.current-packages-puffs .big .front');
        puffSlide1.on('touchStart', function() {
            $(firstSlide1).addClass('active');
            console.log('conferens start');
        });

        puffSlide1.on('reachBeginning', function() {
            $(firstSlide1).removeClass('active');
            console.log('conferens stop');
        });*/

        // Conferens puffs
        var firstSlide = $('.conferens-puffs .big .front');
        var puffSlide2 = new Swiper('.conferens-puffs .content', {
            grabCursor: true,
            slidesPerView: 'auto',
            preloadImages: false,
            lazy: true,
            keyboard: {
                enabled: true
            },

            on: {
                init: function (touchStart) {
                    $(firstSlide).removeClass('active');
                },
                init: function (reachBeginning) {
                    $(firstSlide).removeClass('active');
                }
            }
        });

        /*var firstSlide = $('.conferens-puffs .big .front');
        puffSlide2.on('touchStart', function() {
            $(firstSlide).addClass('active');
            console.log('slide start');
        });

        puffSlide2.on('reachBeginning', function() {
            $(firstSlide).removeClass('active');
            console.log('slide stop');
        });*/

        // Conferens/activity puffs
        var firstSlide2 = $('.activity-puffs .big .front');
        var puffSlide3 = new Swiper('.activity-puffs .content', {
            grabCursor: true,
            slidesPerView: 'auto',
            preloadImages: false,
            lazy: true,
            keyboard: {
                enabled: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                init: function (touchStart) {
                    $(firstSlide2).removeClass('active');
                },
                init: function (reachBeginning) {
                    $(firstSlide2).removeClass('active');
                }
            }
        });

        
        /*puffSlide3.on('touchStart', function() {
            $(firstSlide2).addClass('active');
            console.log('slide start');
        });

        puffSlide3.on('reachBeginning', function() {
            $(firstSlide2).removeClass('active');
            console.log('slide stop');
        });*/

        // Gallery slider

        var swiper2 = new Swiper('.gallery', {
            speed: 800,
            grabCursor: true,
            preloadImages: false,
            lazy: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction'
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: true
            },
            loop: {
                loop: true
            }
        });

        // Hero slider

        var swiper3 = new Swiper('.image-slider', {
            speed: 1500,
            effect: 'fade',
            preloadImages: false,
            lazy: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            autoplay: {
                delay: 5000
            },
            loop: {
                loop: true
            }
        });

        // Sec Hero slider

        var swiper4 = new Swiper('.sec-hero-image-slider', {
            speed: 1500,
            effect: 'fade',
            preloadImages: false,
            lazy: true,
            pagination: {
                clickable: true,
                el: '.swiper-pagination'
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: true
            },
            loop: {
                loop: true
            }
        });

        // Gallery on single news and offer page slider

        var swiper5 = new Swiper('.right-slider ', {
            speed: 800,
            preloadImages: false,
            lazy: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction'
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: true
            },
            loop: {
                loop: true
            }
        });

        // Footer review slider (no images)
        var swiper6 = new Swiper('.get-reviews', {
            speed: 800,
            autoplay: {
                delay: 5000,
                disableOnInteraction: true
            },
            loop: {
                loop: false
            }
        });

        // DYN Hero slider

        var swiper7 = new Swiper('.dyn-image-slider', {
            speed: 2000,
            effect: 'fade',
            preloadImages: false,
            lazy: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            autoplay: {
                delay: 5000
            },
            loop: {
                loop: true
            }
        });
    });
})(jQuery);

//# sourceMappingURL=swiper-controls.js.map
